export enum ReportType {
  CRM = "crm",
  Intermediary = "intermediary",
  Advisor = "advisor",
  AccountManagement = "account-management",
  ExchangeInformation = "exchange-information",
  AnnualReport = "annual-report",
}
